const serviceUrl = `${__configuration.apiUrl}/massia/label-ce`;

export default class LabelCeService {
    static $inject = ['$http'];

    constructor($http) {
        this.$http = $http;
    }
}
